import { VisualQueryFilter } from "@hightouch/lib/query/visual/types";
import isEqual from "lodash/isEqual";
import { useState } from "react";

export interface QueryMetadata {
  subsetIds: string[] | undefined;
  isFastQuery: boolean;
  destinationId: string | undefined;
}

export interface Query extends QueryMetadata {
  filter: VisualQueryFilter;
}

export const useLastUsedQuery = (initialQuery: Query | null) => {
  return useState<Query | null>(initialQuery);
};

export const hasQueryChanged = (
  query1: Query | null,
  query2: Query | null,
): boolean => !isEqual(query1, query2);
